import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PerTableActionButtons } from '../../components/custom_components/TableActionButtons'
import PerText from '../../components/custom_components/Text'
import { atobUtf8, useObjectiveAttachmentHelper } from '../../shared/useObjectiveAttachmentHelper'
import { ObjectiveDto } from '../../types'
import { getObjectiveAttachmentHref } from '../meeting/util/hrefUtils'

interface EmployeeTargetsComponentActionButtonsProps {
  handleObjectiveClicked: (isManagerPreparation: boolean, objective: ObjectiveDto) => void
  objective: ObjectiveDto
  employeeId: string
}

export const EmployeeTargetsComponentActionButtons: FC<EmployeeTargetsComponentActionButtonsProps> = ({
  handleObjectiveClicked,
  objective,
  employeeId,
}) => {
  const [isVisibleAttachmentPopover, setIsVisibleAttachmentPopover] = useState<boolean>(false)
  const { extractHumanReadableFileName } = useObjectiveAttachmentHelper(atobUtf8)
  const [t] = useTranslation()

  return (
    <PerTableActionButtons
      destroyTooltipOnHide
      justify="center"
      buttons={[
        {
          icon: 'view_fill',
          color: 'primary',
          tooltip: t('tooltip.view'),
          onClick: () => handleObjectiveClicked(false, objective),
        },
        {
          icon: 'attachment_fill',
          color: 'primary',
          variant: 'pastel',
          tooltip: t('okr.objective.attachment'),
          showOnlyWhen: !!(objective.attachment && objective.attachmentDownloadToken && employeeId),
          popover: {
            placement: 'top',
            width: 'auto',
            title: <PerText color="secondary">{t('okr.objective.attachment')}</PerText>,
            content: objective.attachment && objective.attachmentDownloadToken && employeeId && (
              <PerText color="secondary">
                <a href={getObjectiveAttachmentHref(employeeId, objective.attachment, objective.attachmentDownloadToken)}>
                  {extractHumanReadableFileName(objective.attachment)}
                </a>
              </PerText>
            ),
            visible: isVisibleAttachmentPopover,
            onVisibleChange: () => setIsVisibleAttachmentPopover(!isVisibleAttachmentPopover),
          },
        },
      ]}
    />
  )
}
